import React, { Component } from 'react'
import './Footer.css'
import PropTypes from 'prop-types'

class Footer extends Component {
    render () {
        return (
            <div className ="footer" data-testid="Footer_divId_test">
                {this.props.children}
            </div>
        )
    }
}

Footer.propTypes = {
    children: PropTypes.any
}

export default Footer
